const drawJourneyTracking = (travelMap: any, journey: any) => {
  if (!journey) {
    return
  }
  const journeyVehicle = journey.vehicle
  if (journey.status === 5 || journey.status === 6) {
    // Đang vận chuyển / kết thúc
    travelMap?.ready().then(() => {
      const { startAtLocation, stopAtLocation, tracking, travelDetails, positionsAndWaitingTasks } = journey
      const { paths, last24hPaths } = tracking
      let { vehicleLocation } = tracking
      const lastStageInd = travelDetails.findIndex((travel: any) => travel.type === 'stage' && !travel.ata)
      const lastStage = travelDetails.find((travel: any) => travel.type === 'stage' && !travel.ata)
      let lastStageIndex = -1
      if (lastStage) {
        lastStageIndex = lastStage.index
      }
      const nextStage = positionsAndWaitingTasks[lastStageIndex]
      const tmpStopLocation = nextStage || stopAtLocation
      if (!vehicleLocation) {
        vehicleLocation = journeyVehicle?.gpsInfo
      }
      travelMap.renderExpectedPaths(tmpStopLocation, vehicleLocation, journeyVehicle)
      travelMap.renderTrackingPaths(startAtLocation, vehicleLocation, paths)
    })
  } else {
    travelMap?.ready().then(() => {
      travelMap.renderExpectedPaths(null, null, journeyVehicle)
    })
  }
}
export { drawJourneyTracking }
